import { render, staticRenderFns } from "./test-id.vue?vue&type=template&id=252f9b86"
import script from "./test-id.vue?vue&type=script&lang=ts"
export * from "./test-id.vue?vue&type=script&lang=ts"
import style0 from "./test-id.vue?vue&type=style&index=0&id=252f9b86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports